// extracted by mini-css-extract-plugin
export const navBar = "layout-module--navBar--2u4NL";
export const visible = "layout-module--visible--3xZ5D";
export const logo = "layout-module--logo--C-Wen";
export const rightBlock = "layout-module--rightBlock--3rMUc";
export const activeMenu = "layout-module--activeMenu--2OmkJ";
export const burgerMenu = "layout-module--burgerMenu--1PRtR";
export const active = "layout-module--active--1K8n1";
export const footerSection = "layout-module--footerSection--3Muvt";
export const goUpBtn = "layout-module--goUpBtn--1kLvA";
export const goUp = "layout-module--goUp--3dhsP";
export const networkBlock = "layout-module--networkBlock--l95og";
export const networkBtn = "layout-module--networkBtn--u0j-a";
export const networkSVG = "layout-module--networkSVG--RWeoF";
export const creator = "layout-module--creator--1a7R9";